import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "31",
      height: "31",
      x: ".5",
      y: ".5",
      stroke: "currentColor",
      rx: "15.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m19.48 15.167-4.084-4.084a.76.76 0 0 1-.24-.583.84.84 0 0 1 .26-.583.88.88 0 0 1 .584-.24.76.76 0 0 1 .583.24l5.5 5.5a.7.7 0 0 1 .177.27.9.9 0 0 1 .052.313.9.9 0 0 1-.052.313.7.7 0 0 1-.177.27l-5.5 5.5a.78.78 0 0 1-.573.23.85.85 0 0 1-.593-.23.8.8 0 0 1-.25-.593q0-.344.25-.594l4.062-4.063h-9.312a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.593q0-.354.24-.594t.594-.24z"
    }, null, -1)
  ])))
}
export default { render: render }